<script setup lang="ts">
import {AdminPages, Model} from "@/app/Model";
import {Comms} from "@/app/Comms";
import {CommsFamiglia} from "@/app/CommsFamiglia";
import {CommsResponsabilita} from "@/app/CommsResponsabilita";
declare let frontendConfig: any;
let model: Model = Model.getReactiveInstance();
let comms: Comms = Comms.getInstance();
let commsFamiglia: CommsFamiglia = CommsFamiglia.getInstance();
let commsResponsabilita: CommsResponsabilita = CommsResponsabilita.getInstance();

function setAdminPage(page: AdminPages): void {
  switch (page) {
    case AdminPages.Penale_Penale:
      if (model.pen_admin.listaPenale.length == 0 ) comms.penaleAdmin.chiamataPenaleList();
      break;
    case AdminPages.Penale_ReatoRubrica:
      if (model.pen_admin.listaReatoRubrica.length == 0 ) comms.penaleAdmin.chiamataReatoRubricaList();
      break;
    case AdminPages.Penale_Procedure:

      break;
    case AdminPages.Famiglia_Famiglia:
      if (model.fam_admin.listaFamiglia.length == 0 ) commsFamiglia.famigliaAdmin.chiamataFamigliaList();

      if (model.fam_lista_citta.length == 0) {
        commsFamiglia.listCitta();
      }
      break;
    case AdminPages.Responsabilita_Responsabilita:
      if (model.res_admin.listaResponsabilita.length == 0 ) commsResponsabilita.responsabilitaAdmin.chiamataResponsabilitaList();

      if (model.res_lista_citta.length == 0) {
        commsResponsabilita.listCitta();
      }
      break;
  }

  model.adminPage = page;
}
function renderClass(page: AdminPages): string {
  let out: string = 'btn mb-2';
  if (model.adminPage == page) out += '';
  else out += ' btn-error';
  return out;
}

function viewMassive(): boolean {
  return frontendConfig.adminPenaleMassive;
}
</script>

<template>
  <ul class="nav flex-column adminMenu">
    <li class="nav-item">
      <button type="button" :class="renderClass(AdminPages.Home)" @click="setAdminPage(AdminPages.Home)">
        <i class="bi bi-pen"></i>
        Admin Home
      </button>
    </li>
    <li class="nav-item sottotitolo">PENALE</li>
    <li class="nav-item">
      <button type="button" :class="renderClass(AdminPages.Penale_Penale)" @click="setAdminPage(AdminPages.Penale_Penale)">
        <i class="bi bi-file-earmark"></i>
        Penale
      </button>
    </li>
    <li class="nav-item">
      <button type="button" :class="renderClass(AdminPages.Penale_ReatoRubrica)" @click="setAdminPage(AdminPages.Penale_ReatoRubrica)">
        <i class="bi bi-journal"></i>
        Reato Rubrica
      </button>
    </li>
    <li class="nav-item" v-if="viewMassive()">
      <button type="button" :class="renderClass(AdminPages.Penale_Procedure)" @click="setAdminPage(AdminPages.Penale_Procedure)">
        <i class="bi bi-capsule"></i>
        Procedure Massive
      </button>
    </li>
    <li class="nav-item sottotitolo">FAMIGLIA</li>
    <li class="nav-item">
      <button type="button" :class="renderClass(AdminPages.Famiglia_Famiglia)" @click="setAdminPage(AdminPages.Famiglia_Famiglia)">
        <i class="bi bi-file-earmark"></i>
        Famiglia
      </button>
    </li>
    <li class="nav-item sottotitolo">RESPONSABILITA'</li>
    <li class="nav-item">
      <button type="button" :class="renderClass(AdminPages.Responsabilita_Responsabilita)" @click="setAdminPage(AdminPages.Responsabilita_Responsabilita)">
        <i class="bi bi-file-earmark"></i>
        Responsabilità
      </button>
    </li>
  </ul>
</template>